import axios from "axios";
import { API_CORE_URL } from "_config/constants/app.constants";
import { useToast } from "_hooks";

// const defaultConf = {
//   paramsSerializer: function (params) {
//     return qs.stringify(params, {
//       arrayFormat: "index",
//       encode: false,
//     });
//   }
// };

const request = ({ baseUrl, endpoint, type, withCredentials = false, ...extras}) => axios({
    baseURL: `${baseUrl || API_CORE_URL}`,
    method: type || "get",
    url: endpoint,
    headers: {
      "Content-Type": "application/json"
    },
    withCredentials,
    ...extras || {}
  })
  .then((response) => response.data)
  .catch((e) => {
    if (extras?.feedback?.error && extras?.feedback?.error !== false) {
      let { toast } = useToast();
      toast("Error", "error");
    }

    return  {
      error: e?.response?.data ?? {
        message: e.message,
        name: e.name
      }
    }
  });

export default request;
